import type { IconDefinition } from '../index.tsx';

export const iconAlertCircle: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconAlertCircle',
  icon: [
    16,
    16,
    [],
    '',
    'M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7 9V3H9V9H7ZM7 13V11H9V13H7Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
